import { render, staticRenderFns } from "./SoccerScoresCompetitors.vue?vue&type=template&id=551df1d0&"
import script from "./SoccerScoresCompetitors.vue?vue&type=script&lang=js&"
export * from "./SoccerScoresCompetitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports